<template>
    <div @mouseleave="hover = false" @mouseover="hover = true" class="invite-content">
        <div :class="{ 'color-silver': !filled }" class="invite-left">{{ fullName }} <span class="color-silver"
                                                                                           v-if="lead">(you)</span>
        </div>

        <div class="invite-right d-flex flex-column justify-content-center">
            <div v-if="filled && (!hover || lead)" v-text="phone"></div>
            <button @click="showInviteModal" class="btn-text" type="button" v-else v-text="label">Add</button>
        </div>

        <div v-if="!lead">
            <input :name="'housemate[' + this.index + '][first_name]'" :value="firstName" type="hidden">
            <input :name="'housemate[' + this.index + '][last_name]'" :value="lastName" type="hidden">
            <input :name="'housemate[' + this.index + '][phone_number]'" :value="phone" type="hidden">
        </div>
    </div>
</template>

<script>
    import store from "../../../store";

    export default {
        name: "InviteBody",

        props: {
            'index': {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                hover: false
            }
        },

        methods: {
            showInviteModal() {
                store.commit('invite/showInviteModal', this.$props.index);
            },
        },

        computed: {
            user() {
                return this.$store.getters['invite/getUser'](this.index);
            },

            filled() {
                return !_.isEmpty(this.user);
            },

            fullName() {
                if (this.firstName && this.lastName) {
                    return this.firstName + ' ' + this.lastName;
                } else {
                    return 'Bill Payer ' + (this.index + 1);
                }
            },

            firstName() {
                let user = this.user;
                if (user !== null && 'first_name' in user) {
                    return user.first_name;
                } else {
                    return null;
                }
            },

            lastName() {
                let user = this.user;

                if (user !== null && 'last_name' in user) {
                    return user.last_name;
                } else {
                    return null;
                }
            },

            phone() {
                let user = this.user;

                if (user !== null && 'phone_number' in user) {
                    return user.phone_number.formatted
                        ? user.phone_number.formatted
                        : '+' + user.phone_number.country_code + user.phone_number.national_number;
                } else {
                    return null;
                }
            },

            lead() {
                let user = this.user;

                if (user !== null && 'pivot' in user && 'is_lead' in user.pivot) {
                    return user.pivot.is_lead;
                } else {
                    return false;
                }
            },

            label() {
                if (this.filled) {
                    return 'Edit';
                } else {
                    return 'Add';
                }
            },
        }

    }
</script>
